import { BankingReconciliationSidePanelDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import NewReconciliationSidePanel from 'modules/banking/components/NewReconciliationSidePanel'
import { ReconciliationFromBankAccountSidePanel } from 'modules/finance/components/ReconciliationFromBankAccountSidepanel'

const BankingReconciliationSidePanel = () => {
  const { data } = useQuery(BankingReconciliationSidePanelDocument)

  if (!data) return null

  const reconcileWithJournalLines =
    data?.banking?._policies.reconciliationsSeeJournalEntriesPage.can ?? false

  return reconcileWithJournalLines ? (
    <ReconciliationFromBankAccountSidePanel />
  ) : (
    <NewReconciliationSidePanel />
  )
}

export default BankingReconciliationSidePanel
